// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "@media(max-width: 600px){.v-card[data-v-bf4e471e]{padding-bottom:10px}}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/product/components/ConfirmationUpdateDialog.vue"],"names":[],"mappings":"AAIC,yBADD,yBAEE,mBAAA,CAAA","file":"ConfirmationUpdateDialog.vue","sourcesContent":["\n@import \"../../../stylesheet/variable.scss\";\n\n.v-card {\n\t@media (max-width: $xs) {\n\t\tpadding-bottom: 10px;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
